/* eslint-disable max-len */
import {React, useState,useEffect, useCallback, useContext } from 'react'
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle'
import { selectAllRows } from '../../../../redux/MultiselectRows'
import { useDispatch, useSelector } from 'react-redux'
import FilterProviderBtn from '../../../ManageProvider/Components/ManageProviderActivityHistory/Component/Filter'
import { useSearchParams } from 'react-router-dom'
import Debounce from '../../../../CommonMethods/Debounce'
import GlobalContext from '../../../../components/Context/GloablContext'
import { handleAddFilterValues, handleIsViewScreen, resetFilterState } from '../../../../redux/systemConfigSlice'
import {useGetProviderAssociatedPatientListQuery,useAssociatePatientToProviderMutation} from '../../../../features/providerSlice'
import CustomOverLay from '../../../../components/CustomOverLay'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import FilterObserverBtn from '../../../ManageObserver/Components/ManageObserverActivityHistory/Component/Filter'
import Limit from '../../../../components/Limit'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import Emptyscreen from '../../../../components/EmptyScreen'
import Pagination from '../../../../components/Pagination'
import moment from 'moment'
import { resetArrays } from '../../../../redux/MultiselectRows'
import { toggleRowSelection } from '../../../../redux/MultiselectRows'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import PermissionErrorEmptyScreen from '../../../../components/Emptyscreenwithouttitle/PermissionErrorEmptyScreen'


export default function PatientAssociatedListProvider({orgDetails,providerId}) {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const [dateError, setdateError] = useState(false)
    const [skip,setSkip]=useState(true)
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [associatePatient] = useAssociatePatientToProviderMutation()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [loading,setLoading] = useState(false)

    const [searchParamsPatient, setSearchParamsPatient] = useSearchParams({});
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.topCheckBox)
    const selectedIds=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const pageNumber=Number(searchParamsPatient.get('page_number')) || 1


    
    const excludedParams = ['view'];
    const filteredSearchParams = new URLSearchParams(window.location.search);
    filteredSearchParams.set('filter', 'true');
    excludedParams.forEach(param => filteredSearchParams.delete(param)); // Remove excluded parameters

    const combinedIdParams = `${providerId}/patients/unlinked?${filteredSearchParams.toString()}`;

    const { data, isFetching, isLoading, status ,refetch,error} = useGetProviderAssociatedPatientListQuery(combinedIdParams, { skip: skip });
   
    
    
    const dispatch=useDispatch()
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',

    }
    const [filterValues,setFilterValues]=useState(initialState)

    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParamsPatient);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        if(key==='subdivision_id'||key==='limit'){
            params[key] = value
        }
        else {
            params[key] = value
        } 
        //if (params.search === '') delete params.search
        setSearchParamsPatient({ ...params})
    }


    const handleCheckboxChange = (Patient) => {
        dispatch(toggleRowSelection([Patient?.patient_id,pageNumber.toString(),data?.data,Patient?.user_name,'active']))
    };
   

    useEffect(() => {
        if (searchParamsPatient.size < 4) {
            setSearchParamsPatient({
                view: 'patient-list',
                page_number: '1',
                limit: '15',
                subdivision_id: orgDetails.subdivision_id,
            });
        }

        return () => {
            dispatch(resetArrays());
        };
    }, []);

    useEffect(()=>{
        if(searchParamsPatient.size>=4){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParamsPatient])

    useEffect(() => {
        if (!skip) {
            refetch();  // Force refetch when skip becomes false
        }
    }, [skip, refetch]);
   

    const handleAllRowsSelect=(event)=>{
        const paramstoPass=[event.target.checked,pageNumber.toString(),data.data]
        dispatch(selectAllRows(paramstoPass))  
    }

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParamsPatient);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParamsPatient({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParamsPatient)
        setSearchParamsPatient({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParamsPatient]
    );

    
    const handleApplyFilter=(type)=>{
        let params = Object.fromEntries(searchParamsPatient);
        const start_date=moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date":filterValues.filter_start_date,
            "filter_end_date":filterValues.filter_end_date,

        }))
        if(type){
            params.page_number=1
            filterValues.filter_start_date!==""?params["start_date"]=Math.floor(Date.parse(start_date) / 86400000) * 86400:''
            filterValues.filter_end_date!==""?params["end_date"]=Math.floor(Date.parse(end_date) / 86400000) * 86400 + 86399:''
            // params["filter"] = "true"; // Append 'filter=true' only when applying filter
            setSearchParamsPatient({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            // params.filter&&delete params.filter
            setSearchParamsPatient({ ...params})
        }   
    }
    
    const handleOpenFilter = () => {
        setdateError(false)
        if ((searchParamsPatient.get("start_date") !== null || searchParamsPatient.get("end_date") !== null) && !isFilterOpen) {
            setFilterValues(filtervals)
        }
        else if (searchParamsPatient.get("start_date") === null && searchParamsPatient.get("end_date") === null) {
            setFilterValues({
                "filter_start_date": '',
                "filter_end_date": '',
            })
        }  
        setIsFilterOpen(!isFilterOpen)
    }

    const onClickAssociate = (e) => {
        e.preventDefault();
        setConfirmationState((prev) => ({ ...prev, isOpen: true, multirow: 'active', rowData: "", user_names: selectedIds.map((item) => item.id) }))
        
    }

    const handleOnCLickActivate = async(e) => {
        
        try {
            let body = {
                patients: confirmationState.user_names, // Assuming confirmationState.user_names contains the patient IDs
                subdivision_id: orgDetails.subdivision_id // Subdivision ID from orgDetails
            };
            setLoading(true)  
            const activationRes=await associatePatient({providerId,body})
            setLoading(false)
            if(activationRes?.data?.message){
                setToastmessage(activationRes?.data?.message)
                setSearchParamsPatient({})
            }else{
                setToastErrorMessage(activationRes?.error?.data?.message)
                
            }
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    const handleConformationClick = () => {
        setConfirmationState({});
    }



    return (
        <div className='border border-[#EDD7E1] mt-4 rounded'>
            <div className='flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px] relative'>
                <div className='flex justify-between items-center w-full'>
                    <p className='text-base font-semibold text-[#972E4C]'>Patient List</p>
                    <div className='flex items-center'>
                        {((searchParamsPatient.get("start_date") !== null || searchParamsPatient.get("end_date") !== null) || (data?.data?.length !== 0 && data !== undefined)) &&
                        <FilterObserverBtn
                            dateError={dateError}
                            setdateError={setdateError}
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter} 
                            MonitorPatientList={true}
                            
                        />
                        }
                        {data?.data?.length>0&&<button
                            type='button'
                            id="associate"
                            disabled={selectedIds?.map((item)=>item?.id)?.length<=0}
                            onClick={(e)=>{onClickAssociate(e)}}
                            className={`ml-2.5 py-2 px-2.5 rounded-[16px] disabled:bg-[#777C88] disabled:border-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C] text-[18px] leading-6 font-normal text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                            Associate
                        </button>}
                    </div>
                </div>
            </div>
            <div className='relative'>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading patient list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center h-[calc(100vh-332px)] w-full`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                    <div className="overflow-auto max-h-[calc(100vh-332px)] scrollbar_purple">
                        <table aria-label="Outside Table" className="w-full table-auto">
                            <thead>
                                <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-[1] sticky top-0 left-0">
                                    <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                        <div className="relative checkbox custom-checkBoxBlue1">
                                            <input type="checkbox" id={pageNumber} data-testid="checkbox" checked={selectedRows?.find(item=>item.page_number===pageNumber.toString())?.isChecked?true:false} onChange={handleAllRowsSelect}/>
                                            <label htmlFor={pageNumber} className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                        </div>
                                    </th>
                                    <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Patient ID
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            First Name
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Middle Name
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Last Name
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Username
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[150px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Primary Identifier
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[180px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Secondary Identifier
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[200px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Created Date
                                        </span>
                                    </th>
                                    <th className="px-[18px] py-2 min-w-[140px] rounded-tl-sm rounded-bl-sm">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                            Date Of Birth
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                                
                                {data?.data && data?.data?.length>0 && data?.data?.map((Patient, index) => (
                                    <tr key={index}  className={`${selectedIds?.some((obj)=>obj?.id===Patient?.patient_id)?"bg-[#F8EEF1]":"bg-[#FFFFFF]"} rounded-[2px] hover:bg-[#F8EEF1] table-tr `}>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                            <div className="relative checkbox custom-checkBoxBlue1">
                                        
                                                <input type="checkbox" 
                                                    id={index+'patient_monitor'} data-testid={`${index}patients`} checked={selectedIds?.some((obj)=>obj.id===Patient?.patient_id)?true:false} 
                                                    onChange={()=>handleCheckboxChange(Patient)} className='cursor-pointer prevent-click' />
                                                <label 
                                                    htmlFor={index+'patient_monitor'}
                                                    className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click"></label>
                                            </div>                    
                                        </td>
                                        <td id='patient_id' className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                            {Patient?.patient_id}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                            {Patient?.first_name}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.middle_name===''?"-":Patient?.middle_name}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.last_name}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.user_name}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.primary_identifier}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.secondary_identifier===""?"-":Patient?.secondary_identifier}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {convertEpochToDateFormat(Patient?.created_at,dateformat)}
                                        </td>
                                        <td className="px-[18px] py-2 text-sm text-start font-normal">
                                            {Patient?.date_of_birth}
                                        </td>
                                    </tr>

                                ))}
                                    
                            </tbody>
                        </table>
                    </div>
                    {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]" >
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                                isColumnSelect={isColumnSelect}
                            />
                            
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParamsPatient?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                    
                            />
                        </div>
                    </div>}
                </>:<>
                    {
                        error?.data?.message === "You don't have access to the subdivision" ? (
                            <PermissionErrorEmptyScreen 
                                message={`You don't have access to the subdivision`}
                                height={'h-[calc(100vh-400px)]'}
                            />
                                
                        ) : data?.data?.length === 0 && (searchParamsPatient.get("start_date") !== null || searchParamsPatient.get("end_date") !== null) ? (
                            <SearchEmptyScreen
                                monitorPatientList={true}
                                text={"That filter combination has no result. Please try different criteria"}
                            />
                        ) : data?.total_count === 0 && !searchParamsPatient.get("search") ? (
                            <Emptyscreen
                                monitorPatientList={true}
                                title={"Manage Provider"}
                                FirstPTag={"No patients to associate"}
                                // SecondePTag={"Start adding by clicking 'Associating Patient’"}
                            />
                        ) : (
                            <SearchEmptyScreen text={"No data found"} />
                        )
                    }

                </>}

            </div>
            {confirmationState.isOpen  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt
                        emptyField={''}
                        setEmptyField={()=>{}}
                        disabled={loading}
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`Associate Patients`}
                        message = {`Are you sure you want to associate the following patients?`}
                        textMessage = {false}
                        buttonName = {'Associate'}
                        userList={selectedIds.map((item) => item.name)}
                        loadingActivation={loading}
                    />
                }
            /> 
            }
        </div>
    )
}